module dg.lists {

    export class ListItemSelectedChannelService {

        public constructor(
            private $rootScope: ng.IScope
        ) { }

        private readonly ITEM_SELECTED = 'ITEM_SELECTED';

        public itemSelected = (item: any) => {
            this.$rootScope.$broadcast(this.ITEM_SELECTED, item);
        }

        public onItemSelected = ($scope: ng.IScope, handler: (item: any) => any) => {
            return $scope.$on(this.ITEM_SELECTED, (event, item) => {
                handler(item);
            });
        }
        
    }

    angular.module('dg.lists')
        .service('listItemSelectedChannelService', ListItemSelectedChannelService);
}

